<template>
  <div class="video-analyse">
    <el-tabs v-model="activeVideoAnalyseTabsName" v-loading="videoAnalyseTabsLoaidng" class="video-analyse-tabs" type="border-card">
      <el-tab-pane name="video_deconstruct" label="基础信息">
        <div v-if="fileDataIsExist" class="video-deconstruct-content">
          <div class="deconstruct-item deconstruct-item-wrapper">
            <el-row type="flex" align="middle" justify="space-between" style="min-height:30px">
              <div class="item-title">分镜脚本</div>
              <el-row type="flex" align="middle">
                <template v-if="showReloadAnalyseBtn">
                  <el-button v-if="lockBtnPermission" type="text" :loading="lockDataMap['is_lock_story'].lockLoading" :disabled="lockDataMap['is_lock_summary'].reloadDisabled || lockDataMap['is_lock_breakdown'].reloadDisabled" @click="toggleLock('is_lock_story', 1)">{{ lockDataMap['is_lock_story'].lockBtnName }}</el-button>
                  <el-button v-if="reloadBtnPermission" type="text" :loading="lockDataMap['is_lock_story'].reloadLoading" :disabled="lockDataMap['is_lock_story'].reloadDisabled" @click="getPlayVideoAnalyse('is_lock_story', 1)">{{ lockDataMap['is_lock_story'].reloadBtnName }}</el-button>
                </template>
              </el-row>
            </el-row>
            <div class="deconstruct-details">
              <script-section :video-script="fileData.storyboard" />
            </div>
          </div>
          <div v-if="fileData.story_summary || fileData.story_details || fileData.turning_point.length > 0" class="deconstruct-item deconstruct-item-content">
            <el-row type="flex" align="middle" justify="space-between" style="min-height:30px">
              <div class="item-title">剧情/故事</div>
              <el-row type="flex" align="middle">
                <template v-if="showReloadAnalyseBtn">
                  <el-button v-if="lockBtnPermission" type="text" :loading="lockDataMap['is_lock_summary'].lockLoading" @click="toggleLock('is_lock_summary', 2)">{{ lockDataMap['is_lock_summary'].lockBtnName }}</el-button>
                  <el-button v-if="reloadBtnPermission" type="text" :loading="lockDataMap['is_lock_summary'].reloadLoading" :disabled="lockDataMap['is_lock_summary'].reloadDisabled" @click="getPlayVideoAnalyse('is_lock_summary', 2)">{{ lockDataMap['is_lock_summary'].reloadBtnName }}</el-button>
                </template>
              </el-row>
            </el-row>
            <div class="deconstruct-details">
              <div class="deconstruct-item">
                <div class="item-title">剧情梗概</div>
                <div class="deconstruct-details-text">{{ fileData.story_summary }}</div>
              </div>
              <div class="deconstruct-item">
                <div class="item-title">故事细节</div>
                <div class="deconstruct-details-text">{{ fileData.story_details }}</div>
              </div>
              <div v-if="fileData.turning_point.length > 0" class="deconstruct-item">
                <div class="item-title">冲突或转折点</div>
                <div class="deconstruct-details-text">{{ fileData.turning_point.join('') }}</div>
              </div>
            </div>
          </div>
          <div v-if="analyseDataKeys.length > 0" class="deconstruct-item deconstruct-item-content">
            <el-row type="flex" align="middle" justify="space-between" style="min-height:30px">
              <div class="item-title">维度分析</div>
              <el-row type="flex" align="middle">
                <template v-if="showReloadAnalyseBtn">
                  <el-button v-if="lockBtnPermission" type="text" :loading="lockDataMap['is_lock_breakdown'].lockLoading" @click="toggleLock('is_lock_breakdown', 3)">{{ lockDataMap['is_lock_breakdown'].lockBtnName }}</el-button>
                  <el-button v-if="reloadBtnPermission" type="text" :loading="lockDataMap['is_lock_breakdown'].reloadLoading" :disabled="lockDataMap['is_lock_breakdown'].reloadDisabled" @click="getPlayVideoAnalyse('is_lock_breakdown', 3)">{{ lockDataMap['is_lock_breakdown'].reloadBtnName }}</el-button>
                </template>
              </el-row>
            </el-row>
            <div class="deconstruct-details">
              <template v-for="keyItem in analyseDataKeys">
                <div v-if="keyItem.type === 'string'" :key="keyItem.key" class="deconstruct-item">
                  <div class="item-title">{{ keysMap[keyItem.key] }}</div>
                  <div class="deconstruct-details-text">{{ fileData[keyItem.key] }}</div>
                </div>
                <div v-else :key="keyItem.key" class="deconstruct-item">
                  <div class="item-title">{{ keysMap[keyItem.key] }}</div>
                  <div class="deconstruct-details-tag">
                    <el-tag v-for="(item, index) in fileData[keyItem.key]" :key="item" :type="getTagType(index)">{{ item }}</el-tag>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <JilementEmpty v-if="activeVideoAnalyseTabsName === 'video_deconstruct' && !fileDataIsExist" description="无数据" />
      </el-tab-pane>
      <el-tab-pane name="video_speech_split_text" label="口播">
        <div v-if="fileDataIsExist" class="video-speech-split-text-content">
          <el-row v-for="videoText in fileData.storyboard" :key="videoText.end_time" type="flex" class="split-item">
            <el-button type="text" @click="handleClickVideoTime(videoText)">{{ `${getSeconds(videoText.start_time)}-${getSeconds(videoText.end_time)}s` }}</el-button>
            <div class="detail">{{ videoText.text }}</div>
          </el-row>
        </div>
        <JilementEmpty v-if="activeVideoAnalyseTabsName === 'video_speech_split_text' && !fileDataIsExist" description="无数据" />
      </el-tab-pane>
      <!-- <el-tab-pane name="video_lables" label="标签">标签</el-tab-pane> -->
    </el-tabs>
    <el-row class="btn-row" type="flex" align="middle" justify="space-between">
      <i class="el-icon-document-copy btn-icon" title="复制分析内容" @click="handleCopyVideoAnalyse" />
      <el-button v-if="fileDataIsExist && showSaveVideoScriptBtn" :loading="saveVideoScriptLoading" type="primary" @click="saveVideoScript">保存脚本</el-button>
      <!-- <i class="el-icon-refresh-right btn-icon" title="重新分析视频" @click="getPlayVideoAnalyse" /> -->
    </el-row>
  </div>
</template>

<script>
import JilementEmpty from '@/views/components/JilementEmpty'
import ScriptSection from '@/views/dsp/videoScript/component/ScriptSection'
import { lockStoryAnalyse, getButtonPermission } from '@/api/dsp/file'
import { addVideoScript } from '@/api/dsp/videoScript'

export default {
  name: 'VideoAnalyse',
  components: {
    JilementEmpty,
    ScriptSection
  },
  props: {
    fileData: {
      type: Object,
      default: () => {}
    },
    playFileData: {
      type: Object,
      default: () => null
    },
    playDom: {
      type: Object,
      default: () => null
    },
    playIndex: {
      type: Number,
      default: 0
    },
    videoAnalyseTabsLoaidng: {
      type: Boolean,
      default: false
    },
    reloadAnalyse: {
      type: Boolean,
      default: true
    },
    showSaveVideoScriptBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeVideoAnalyseTabsName: 'video_deconstruct',
      activeVideoScriptKey: '',
      lockDataMap: {
        'is_lock_story': {
          lockBtnName: '锁定结果',
          reloadBtnName: '重新分析',
          reloadDisabled: false,
          reloadLoading: false,
          lockLoading: false
        },
        'is_lock_summary': {
          lockBtnName: '锁定结果',
          reloadBtnName: '重新分析',
          reloadDisabled: false,
          reloadLoading: false,
          lockLoading: false
        },
        'is_lock_breakdown': {
          lockBtnName: '锁定结果',
          reloadBtnName: '重新分析',
          reloadDisabled: false,
          reloadLoading: false,
          lockLoading: false
        }
      },
      loadingLockKey: '',
      keysMap: {
        'video_style': '视频风格',
        'selling_points': '营销卖点',
        'discount_activity': '优惠活动',
        'nouns': '名词',
        'map_scene': '地图或场景',
        'gameplay_or_instance': '玩法或副本',
        'highlight_moment': '爽点',
        'funny_moment': '笑点',
        'sad_moment': '哭点',
        'critique_point': '槽点',
        'target_audience': '目标人群'
      },
      lockBtnPermission: false,
      reloadBtnPermission: false,
      saveVideoScriptLoading: false
    }
  },
  computed: {
    analyseDataKeys() {
      const keys = []
      if (!this.fileDataIsExist) {
        return keys
      }
      const includeKyes = ['video_style', 'selling_points', 'discount_activity', 'nouns', 'map_scene', 'gameplay_or_instance', 'highlight_moment', 'funny_moment', 'sad_moment', 'critique_point', 'target_audience']

      for (const key in this.fileData) {
        if (includeKyes.includes(key) && this.fileData[key] && this.fileData[key].length > 0) {
          keys.push({
            type: typeof this.fileData[key],
            key: key
          })
        }
      }

      return keys
    },
    showReloadAnalyseBtn() {
      return this.reloadAnalyse && this.fileData?.is_ext === 0
    },
    fileDataIsExist() {
      return this.fileData && this.fileData.storyboard
    }
  },
  watch: {
    videoAnalyseTabsLoaidng(val) {
      if (val === false && this.loadingLockKey) {
        // const lockData = this.lockDataMap[this.loadingLockKey]
        // lockData.reloadBtnName = '重新分析'
        // lockData.reloadLoading = false
        // lockData.lockLoading = false
      }
    },
    fileData: {
      immediate: true,
      deep: true,
      handler() {
        const dataMap = {}
        const lockDataKey = ['is_lock_story', 'is_lock_summary', 'is_lock_breakdown']
        const statusKey = ['story_analysing', 'summary_analysing', 'breakdown_analysing']
        if (this.fileDataIsExist) {
          lockDataKey.forEach((key, index) => {
            dataMap[key] = {
              lockBtnName: this.fileData[key] === 0 ? '锁定结果' : '取消锁定',
              reloadBtnName: this.fileData[statusKey[index]] === 1 ? '重新解构中' : '重新分析',
              reloadDisabled: this.fileData[key] === 1 || this.fileData[statusKey[index]] === 1,
              reloadLoading: this.fileData[statusKey[index]] === 1,
              lockLoading: false
            }
          })
        }
        this.lockDataMap = dataMap
      }
    }
  },
  created() {
    this.getButtonPermission()
  },
  methods: {
    getButtonPermission() {
      getButtonPermission().then(res => {
        this.lockBtnPermission = res.data.button.includes('锁定素材分析')
        this.reloadBtnPermission = res.data.button.includes('重新分析素材')
      })
    },
    handleCopyVideoAnalyse() {
      if (!this.fileDataIsExist) {
        this.$message.error('请生成分析数据')
        return
      }
      const copyData = this.getCopyVideoString(this.fileData)
      this.copyLink(copyData)
    },
    getCopyVideoString(videoData) {
      let str = ''
      if (videoData.storyboard.length > 0) {
        str = `基础信息\n`
        str += `${videoData.storyboard.map(item => item.synopsis).join('、')}\n`
        str += `${videoData.storyboard.map(item => item.text).join('')}\n`
      }
      if (videoData.story_summary || videoData.story_details || videoData.turning_point.length > 0) {
        str += `剧情/故事\n`
        if (videoData.story_summary) {
          str += `剧情梗概\n`
          str += `${videoData.story_summary}\n`
        }
        if (videoData.story_details) {
          str += `故事细节\n`
          str += `${videoData.story_details}\n`
        }
        if (videoData.turning_point.length > 0) {
          str += `冲突或转折点\n`
          str += `${videoData.turning_point.join('')}\n`
        }
      }
      if (this.analyseDataKeys.length > 0) {
        str += `维度分析\n`
        this.analyseDataKeys.forEach(item => {
          str += `${this.keysMap[item.key]}\n`
          if (item.type === 'string') {
            str += `${videoData[item.key]}\n`
          } else {
            str += `${videoData[item.key].join('、')}\n`
          }
        })
      }
      return str
    },
    getSeconds(times) {
      return String(parseInt(times / 1000)).padStart(2, '0')
    },
    handleClickVideoTime(data) {
      if (this.playDom) {
        this.playDom.currentTime = data.start_time / 1000
      }
    },
    getPlayVideoAnalyse(key, type) {
      const lockData = this.lockDataMap[key]
      this.$confirm('确定重新分析素材吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loadingLockKey = key
        lockData.reloadBtnName = '重新解构中'
        lockData.reloadLoading = true
        this.$emit('getPlayVideoAnalyse', this.fileData.signature, [type])
      })
    },
    getTagType(index) {
      const typeArr = ['', 'success', 'danger', 'warning']
      return typeArr[index % 4]
    },
    handleMouseEnterVideoScript(key) {
      this.activeVideoScriptKey = key
    },
    handleMouseLeaveVideoScript() {
      this.activeVideoScriptKey = ''
    },
    toggleLock(key, type) {
      const lockData = this.lockDataMap[key]
      const isLock = lockData.lockBtnName === '取消锁定'
      if (isLock) {
        this.$message.error('请联系管理员取消锁定')
        return
      }

      const part = {
        1: '分镜脚本',
        2: '剧情/故事',
        3: '维度分析'
      }[type] ?? ''
      const tipMessage = isLock ? '取消后将可重新分析素材,确定取消锁定？' : `锁定后${part}的重新分析按钮将不可用，确定锁定吗？`
      this.$confirm(tipMessage, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.lockStoryAnalyse(lockData, key, type)
      })
    },
    lockStoryAnalyse(lockData, key, type) {
      if (this.fileData.signature) {
        const param = {
          signature: this.fileData.signature,
          story_request_id: this.fileData.story_request_id,
          summary_request_id: this.fileData.summary_request_id,
          breakdown_request_id: this.fileData.breakdown_request_id,
          analyse_type: type
        }
        lockData.lockLoading = true
        lockStoryAnalyse(param).then(res => {
          lockData.lockBtnName = '取消锁定'
          lockData.reloadDisabled = true
          if (key === 'is_lock_summary' || key === 'is_lock_breakdown') {
            if (lockData.reloadDisabled) {
              this.lockDataMap['is_lock_story'].reloadDisabled = true
              this.lockDataMap['is_lock_story'].lockBtnName = '取消锁定'
            }
          }
          this.$message.success(res.message)
        }).finally(() => {
          lockData.lockLoading = false
        })
      }
    },
    saveVideoScript() {
      if (this.playFileData) {
        const param = {
          script_name: this.playFileData.name,
          signature: this.fileData.signature,
          selling_points: this.fileData.selling_points,
          promotions: this.fileData.promotions,
          targets: this.fileData.targets,
          pain_points: this.fileData.pain_points,
          synopsis: this.fileData.storyboard.map(item => item.synopsis),
          content: this.fileData.storyboard,
          word_number: 0
        }
        this.saveVideoScriptLoading = true
        addVideoScript(param).then(res => {
          this.$message.success(res.message)
        }).finally(() => {
          this.saveVideoScriptLoading = false
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/mixin.scss";
.video-analyse{
  text-align: left;
	.video-analyse-tabs {
    height: 589px;

    .video-deconstruct-content {
      height: 524px;
      overflow: auto;
      padding-right: 6px;
      .deconstruct-item {
        margin-bottom: 24px;
        .item-title {
          font-family: pingfang sc, -apple-system, blinkmacsystemfont, segoe ui, hiragino sans gb, microsoft yahei, helvetica neue, sans-serif, "apple color emoji", "segoe ui emoji";
          font-size: 14px;
          line-height: 22px;
          color: #323335;
          font-weight: 700;
          text-align: left;
        }
        .deconstruct-details {
          .details-header {
              margin-bottom: 8px;
            .header-item {
              .el-tag {
                cursor: pointer;
                margin: 0;
              }
              .split {
                margin: 0 6px;
                color: #999;
              }

              &:last-child .split {
                display: none;
              }
            }
          }

          .details-content {
            text-align: left;
            font-size: 14px;
            .detail-item {
              color: #323335;
              font-size: 14px;

              &.active {
                background: #e5f5ff;
              }
            }
          }
        }

        .deconstruct-details-text {
          text-align: left;
          margin-top: 6px;
          font-size: 14px;
        }

        .deconstruct-details-tag {
          text-align: left;
          .el-tag {
            margin-right: 6px;
            margin-top: 6px;
          }
        }

        &.deconstruct-item-wrapper {
          .deconstruct-details {
            margin-top: 6px;
          }
        }

        &.deconstruct-item-content {
          .deconstruct-details {
            border: solid 1px #dfe0e2;
            border-radius: 8px;
            padding: 14px;
            margin-top: 6px;

            .deconstruct-item:last-child {
              margin-bottom: 0;
            }
          }
        }
      }

      @include scrollBar();
    }

    .video-speech-split-text-content {
      height: 524px;
      overflow: auto;
      .split-item {
        padding-bottom: 4px;
        .el-button {
          height: 20px;
        }
        .detail {
          padding-left: 8px;
          padding-top: 4px;
          text-align: left;
          font-size: 14px;
        }
      }

      @include scrollBar();
    }
  }

  .btn-row {
    padding-top: 10px;
    .btn-icon {
      font-size: 20px;
      margin-right: 10px;
      cursor: pointer;
    }
  }
}
</style>
